import styles from "./HowItWorks.module.css";
import { Link } from "react-router-dom";

const HowItWorks = () => {
    return(
        <div className = {styles.body}>
            <div className = {styles.navbar}>
                <h1 className = {styles.title}>How It Works</h1>
                <Link to = "/" className = {styles.home}>Home</Link>
            </div>
            <div className = {styles.panel}>
                
            </div>
        </div>
    )
}

export default HowItWorks;